import { InitializeScdHandlers } from "@lib/scd/ScdSelectorClientside";
import { HtmxCustomEvent } from  '@lib/htmx/types'

export { InitialiseMultiSelect } from '@lib/utils/multiSelect';

export function ClonePagination(event: HtmxCustomEvent)
{
    const selector = '';
    const top = document.getElementById(selector);
    const bottom = document.getElementById('bottomPagination');

    const node = top?.cloneNode(true);
    if (node) 
    {
        bottom?.appendChild(node);
    }
}

function OnPageButtonClickHandler(event: Event)
{
    
}

export function OnPaginationLoaded()
{
    const items = document.querySelectorAll('.page-item .page-link') as NodeListOf<HTMLAnchorElement>;
    items.forEach(item => item.addEventListener('click', OnPageButtonClickHandler));
}

document.addEventListener('DOMContentLoaded', function() {
    InitializeScdHandlers();
});

